export default __webpack_public_path__ + "static/media/MuseoSansRounded-700.ee62b100.woff2";